const eventsOptions = () => {
    const elements = Array.from(document.querySelectorAll('[data-component="option"]'));
  
    elements.forEach((element) => {
      const elementLabel = element.querySelector('label');
        elementLabel.addEventListener('click', () => {
            if (!elementLabel.classList.contains('events-options__option-label--checked')) {
              elementLabel.classList.add('events-options__option-label--checked');
            } else {
              elementLabel.classList.remove('events-options__option-label--checked');
            }
          })
    });
  };
  
export default eventsOptions;